class BackToTop extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('button');
    this.threshold = Number(this.dataset.threshold) || 400;
    this.onScroll = this.onScroll.bind(this);
    this.onClick = this.onClick.bind(this);
  }

  connectedCallback() {
    window.addEventListener('scroll', this.onScroll, { passive: true });
    this.button.addEventListener('click', this.onClick);
    this.onScroll();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScroll);
    this.button.removeEventListener('click', this.onClick);
  }

  onScroll() {
    this.button.classList.toggle('is-visible', window.scrollY > this.threshold);
  }

  onClick() {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
    document.getElementById('MainContent')?.focus?.({ preventScroll: true });
  }
}

customElements.define('back-to-top', BackToTop);
